import React from "react";
import Button from "@material-ui/core/Button";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
  PDFViewer,
  Font,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";
import { useSelector } from "react-redux";
import CairoBold from "./static/Cairo-Bold.ttf";
import Cairo from "./static/Cairo-Regular.ttf";
import { getCurrencyIcon, getCurrencyIso } from "../../../Helpers/currencyConverter";

Font.register({
  family: "Cairo",
  fonts: [
    {
      src: Cairo,
      fontWeight: 400,
    },
  ],
});
Font.register({
  family: "CairoBold",
  fonts: [
    {
      src: CairoBold,
      fontWeight: 700,
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#E4E4E4",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  table: {
    display: "table",
    width: "auto",
    backgroundColor: "white",
    border: " 0.5px solid gray",
    borderSpacing: 5,
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
  },
  tableCol: {
    flex: 1,
    padding: 5,
  },
  pageArabic: {
    fontFamily: "Cairo",
  },
});
const MyDocument = ({
  productsInCart,
  cart,
  date,
  accountName,
  storeName,
  showPrice,
  vatAmount,
  currency,
  vatTotal,
  discountTotal,
  subtotalAmount,
  totalAmount,
  deliveryTotal,
  vat,
  paymentMethod,
  paymentDays,
  language,
  logo,
  phoneNumber,
  accountEmail,
  dayWeeks,
  address,
  showLogo,
  accountAddress,
  businessName,
}) => (
  <Document>
    <Page
      size="A4"
      style={{
        padding: 10,
        fontFamily: "Cairo",
        textAlign: language === "english" ? "left" : "right",
        color: "#555555",
      }}
    >
      <View
        style={{
          display: logo && showLogo ? "flex" : "",
          flexDirection: language === "english" ? "row" : "row-reverse",
        }}
      >
        {logo && showLogo && (
          <Image
            style={{
              width: 70,
              height: 70,
              objectFit: "contain",
              alignSelf: "center",
              flex: 1,
            }}
            src={logo}
          />
        )}
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
          }}
        >
          <Text
            style={{
              fontSize: 16,
            }}
          >
            {language === "english" ? "Quotation" : "العرض"}
          </Text>
          <Text
            style={{
              fontSize: 12,
            }}
          >
            {storeName}
          </Text>
          <Text
            className="m-0"
            style={{
              fontSize: 12,
            }}
          >
            {`${dayWeeks[language][moment().isoWeekday()]}`}{" "}
            {`${moment().format("D-MMM-YYYY")}`}
          </Text>
          <Text
            style={{
              fontSize: 12,
            }}
          >
            {language === "english" ? "UNPAID QUOTATION" : "عرض غير مدفوع"}
          </Text>
        </View>
        {logo && showLogo && (
          <View
            style={{
              flex: 1,
            }}
          ></View>
        )}
      </View>
      <View
        style={{
          display: "flex",
          flexDirection: language === "english" ? "row" : "row-reverse",
          justifyContent: "space-between",
        }}
      >
        <View
          style={{
            display: "flex",
            flex: 2,
            justifyContent: "space-between",
            flexDirection: "column",
            fontSize: 13,
          }}
        >
          <View
            style={{
              display: "flex",
              flexDirection: language === "english" ? "row" : "row-reverse",
              justifyContent: "space-between",
            }}
          >
            <Text>
              {language === "english" ? "Business Name: " : "اسم الشركة: "}
            </Text>
            <Text
              style={{
                textAlign: "left",
              }}
            >
              {businessName}
            </Text>
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: language === "english" ? "row" : "row-reverse",
              justifyContent: "space-between",
            }}
          >
            <Text>
              {language === "english" ? "Branch Name: " : "اسم الفرع: "}
            </Text>
            <Text
              style={{
                textAlign: "left",
              }}
            >
              {accountName}
            </Text>
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: language === "english" ? "row" : "row-reverse",
              justifyContent: "space-between",
            }}
          >
            <Text>{language === "english" ? "Phone: " : "الهاتف: "}</Text>
            <Text
              style={{
                textAlign: "left",
              }}
            >
              {phoneNumber}
            </Text>
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: language === "english" ? "row" : "row-reverse",
              justifyContent: "space-between",
            }}
          >
            <Text>
              {language === "english" ? "Email: " : "البريد الالكتروني: "}
            </Text>
            <Text
              style={{
                textAlign: "left",
              }}
            >
              {accountEmail}
            </Text>
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: language === "english" ? "row" : "row-reverse",
              justifyContent: "space-between",
            }}
          >
            <Text>{language === "english" ? "Payment: " : "الدفع: "}</Text>
            <Text
              style={{
                textAlign: "left",
              }}
            >
              {paymentMethod}
            </Text>
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: language === "english" ? "row" : "row-reverse",
              justifyContent: "space-between",
            }}
          >
            <Text>
              {language === "english"
                ? "Expected Delivery Date: "
                : "تاريخ التسليم المتوقع:"}
            </Text>
            <Text
              style={{
                textAlign: "left",
              }}
            >
              {date}
            </Text>
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: language === "english" ? "row" : "row-reverse",
              justifyContent: "space-between",
            }}
          >
            <Text>
              {language === "english"
                ? "Expected Payment Date: "
                : "تاريخ الدفع المتوقع:"}
            </Text>
            <Text
              style={{
                textAlign: "left",
              }}
            >
              {moment().add(paymentDays, "days").format("YYYY-MM-DD")}
            </Text>
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: language === "english" ? "row" : "row-reverse",
              justifyContent: "space-between",
            }}
          >
            <View
              style={{
                flex: 1,
              }}
            >
              <Text>{language === "english" ? "Address: " : "العنوان: "}</Text>
            </View>
            <View
              style={{
                flex: 2,
              }}
            >
              <Text
                style={{
                  textAlign: language === "english" ? "right" : "left",
                }}
              >
                {language === "arabic"
                  ? accountAddress?.area_ar
                  : accountAddress?.area}{" "}
                {accountAddress?.block && (
                  <Text>
                    {language === "english"
                      ? ` Block:${accountAddress?.block} `
                      : `القطعة: ${accountAddress?.block} `}
                    {" ,"}
                  </Text>
                )}
                {accountAddress?.street && (
                  <Text>
                    {language === "english"
                      ? ` Street:${accountAddress?.street} `
                      : `الشارع: ${accountAddress?.street} `}
                    {" ,"}
                  </Text>
                )}
                {accountAddress?.avenue && (
                  <Text>
                    {language === "english"
                      ? ` Avenue:${accountAddress?.avenue} `
                      : `المحور: ${accountAddress?.avenue} `}
                    {" ,"}
                  </Text>
                )}
                {accountAddress?.building && (
                  <Text>
                    {language === "english"
                      ? ` Building: ${accountAddress?.building} `
                      : `المبنى: ${accountAddress?.building} `}
                    {" ,"}
                  </Text>
                )}
                {accountAddress?.floor && (
                  <Text>
                    {language === "english"
                      ? ` Floor: ${accountAddress?.floor} `
                      : `الطابق: ${accountAddress?.floor} `}
                    {" ,"}
                  </Text>
                )}
                {accountAddress?.additional && (
                  <Text>
                    {language === "english"
                      ? ` Info: ${accountAddress?.additional} `
                      : `معلومات: ${accountAddress?.additional} `}
                    {" ,"}
                  </Text>
                )}
                {accountAddress?.country && (
                  <Text>
                    {language === "arabic"
                      ? accountAddress?.country_ar
                      : accountAddress?.country}
                  </Text>
                )}
              </Text>
            </View>
          </View>
        </View>
      </View>
      <View
        style={{
          borderBottom: "1px solid #0099cc",
          width: "100%",
          marginTop: 10,
          marginBottom: 10,
        }}
      />
      <View
        style={{
          padding: 10,
        }}
      >
        <View style={styles.table}>
          <View
            style={[
              styles.tableRow,
              {
                fontSize: 14,
                backgroundColor: "#eeeeee",
                fontWeight: "bold",
                fontFamily: "CairoBold",
                flexDirection: language === "english" ? "row" : "row-reverse",
              },
            ]}
          >
            <View
              style={{
                flex: 4,
                padding: 5,
              }}
              align="center"
            >
              <Text>{language === "english" ? "Item" : "المنتج"}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text>{language === "english" ? "Quantity" : "الكمية"}</Text>
            </View>
            {showPrice && (
              <>
                <View style={styles.tableCol}>
                  <Text>{language === "english" ? "Price" : "السعر"}</Text>
                </View>

                <View style={styles.tableCol}>
                  <Text>{language === "english" ? "Amount" : "المجموع"}</Text>
                </View>
              </>
            )}
          </View>
          {productsInCart?.map((product, index) => (
            <View
              style={[
                styles.tableRow,
                {
                  fontSize: 13,
                  flexDirection: language === "english" ? "row" : "row-reverse",
                },
              ]}
            >
              <View
                style={{
                  flex: 4,
                  padding: 5,
                }}
                align="center"
              >
                <Text>
                  {language === "arabic" ? product.ar_name : product.name}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text>{cart[product.id]}</Text>
              </View>
              {showPrice && (
                <>
                  <View style={styles.tableCol}>
                    <Text>{product.price}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text>{product.price * cart[product.id]}</Text>
                  </View>
                </>
              )}
            </View>
          ))}
        </View>
      </View>

      <View
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          fontSize: 14,
        }}
      >
        <View style={{ marginTop: 10, padding: 10, flexGrow: 1 }}>
          <View
            style={{
              borderBottom: "1px solid #555555",
              width: "100%",
            }}
          />
          <View
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: language === "english" ? "row" : "row-reverse",
            }}
          >
            <Text>{language === "english" ? "Subtotal" : "الإجمالي"}</Text>
            <Text>
              {subtotalAmount} {currency}
            </Text>
          </View>
          <View
            style={{
              borderBottom: "1px solid #555555",
              width: "100%",
            }}
          />
          <View
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: language === "english" ? "row" : "row-reverse",
            }}
          >
            <Text>
              {language === "english" ? "Delivery services" : "خدمات التوصيل"}
            </Text>
            <Text>
              {deliveryTotal} {currency}
            </Text>
          </View>
          <View
            style={{
              borderBottom: "1px solid #555555",
              width: "100%",
            }}
          />
          <View
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: language === "english" ? "row" : "row-reverse",
            }}
          >
            <Text>{language === "english" ? "Discount" : "الخصم"}</Text>
            <Text>
              {discountTotal} {currency}
            </Text>
          </View>
          {vat > 0 && (
            <>
              <View
                style={{
                  borderBottom: "1px solid #555555",
                  width: "100%",
                }}
              />
              <View
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: language === "english" ? "row" : "row-reverse",
                }}
              >
                <Text>
                  {language === "english" ? "VAT" : "ضرائب"} {vatAmount}%{" "}
                </Text>
                <Text>
                  {vatTotal} {currency}
                </Text>
              </View>
            </>
          )}
          <View
            style={{
              borderBottom: "1px solid #555555",
              width: "100%",
            }}
          />
          <View
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: language === "english" ? "row" : "row-reverse",
            }}
          >
            <Text>{language === "english" ? "Total" : "المجموع"}</Text>
            <Text>
              {totalAmount} {currency}
            </Text>
          </View>
          <View
            style={{
              borderBottom: "1px solid #555555",
              width: "100%",
            }}
          />
        </View>
      </View>
    </Page>
  </Document>
);
const DownloadQuotation = ({
  cart,
  products,
  disableButton,
  accountName,
  date,
  showPrice,
  vat,
  total,
  discountTotal,
  subtotal,
  deliveryPrice,
  paymentMethod,
  paymentDays,
  accountEmail,
  accountAddress,
  accountPhone,
  businessName,
}) => {
  const domain = useSelector((state) => state.store.store.domain);
  const storeName = useSelector((state) => state.store.store.name);
  const storeNameAr = useSelector((state) => state.store.store.ar_name);
  const language = useSelector((state) => state.store.language);
  const settings = useSelector((state) => state.store.store.settings);
  const applied_promo = useSelector((state) => state.cart.promos);
  const discounts = useSelector((state) => state.cart.discounts);
  const logo = useSelector((state) => state.store.store.logo);
  let productsInCart = [];
  for (const item in cart) {
    if (cart[item] > 0) {
      productsInCart.push(
        products.filter((product) => +product.product.id === +item)[0]?.product
      );
    }
  }
  const currency = getCurrencyIso(settings,language)

  const vatTotal = vat
    ? parseFloat(parseFloat(total) * parseFloat(vat)).toFixed(
        settings.currency_decimals
      )
    : 0;

  const discountAmount = parseFloat(discountTotal ? discountTotal : 0).toFixed(
    settings.currency_decimals
  );
  const vatAmount = parseFloat((vat * 100).toFixed(2));
  const totalAmount = parseFloat(
    parseFloat(total) + parseFloat(vatTotal) - parseFloat(discountAmount)
  ).toFixed(settings.currency_decimals);

  const deliveryTotal =
    (applied_promo && applied_promo.discount_type === "delivery") ||
    discounts.delivery.length
      ? (0.0).toFixed(settings.currency_decimals)
      : deliveryPrice.toFixed(settings.currency_decimals);
  const subtotalAmount = subtotal.toFixed(settings.currency_decimals);
  const paymentMethodText = () => {
    if (paymentMethod === "cash") {
      return language === "english" ? "Cash" : "كاش";
    } else if (paymentMethod === "on-credit") {
      return language === "english" ? "On Credit" : "على الحساب";
    } else {
      return language === "english" ? "Online Payment" : "الدفع الالكتروني";
    }
  };

  const dayWeeks = {
    english: {
      0: "Sunday",
      1: "Monday",
      2: "Tuesday",
      3: "Wednesday",
      4: "Thursday",
      5: "Friday",
      6: "Saturday",
    },
    arabic: {
      0: "الأحد",
      1: "الاثنين",
      2: "الثلاثاء",
      3: "الأربعاء",
      4: "الخميس",
      5: "الجمعة",
      6: "السبت",
    },
  };

  return (
    <div
      style={{
        marginTop: "30px",
      }}
    >
      <p
        className="box-title"
        style={{ textAlign: language === "arabic" ? "right" : "left" }}
      >
        {language === "english" ? "Download Quotation" : "تحميل العرض"}
      </p>
      <div
        className="border-top border-bottom w-100 mx-0 mb-3"
        style={{
          backgroundColor: "white",
          padding: "10px",
          textAlign: language === "arabic" ? "right" : "left",
        }}
      >
        {disableButton ? (
          <PDFDownloadLink
            document={
              <MyDocument
                productsInCart={productsInCart}
                cart={cart}
                accountName={accountName}
                date={date}
                storeName={language === "english" ? storeName : storeNameAr}
                domain={domain}
                showPrice={showPrice}
                businessName={businessName}
                vat={vat}
                vatTotal={vatTotal}
                discountTotal={discountAmount}
                vatAmount={vatAmount}
                subtotalAmount={subtotalAmount}
                currency={currency}
                totalAmount={totalAmount}
                deliveryTotal={deliveryTotal}
                paymentMethod={paymentMethodText()}
                paymentDays={paymentDays}
                language={language}
                logo={logo}
                showLogo={settings.show_logo}
                phoneNumber={accountPhone}
                accountEmail={accountEmail}
                dayWeeks={dayWeeks}
                accountAddress={accountAddress}
              />
            }
            fileName={"quotation"}
          >
            {({ loading }) =>
              loading ? (
                language === "english" ? (
                  "Loading document..."
                ) : (
                  "تحميل المستند ..."
                )
              ) : (
                <Button
                  variant={"contained"}
                  color={"primary"}
                  style={{
                    boxShadow: "none",
                    textTransform: "none",
                  }}
                >
                  {language === "english"
                    ? "Download Quotation"
                    : "تحميل العرض"}
                </Button>
              )
            }
          </PDFDownloadLink>
        ) : (
          <Button
            variant="contained"
            disabled
            color={"primary"}
            style={{
              textTransform: "none",
            }}
          >
            {language === "english" ? "Download Quotation" : "تحميل العرض"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default DownloadQuotation;
